import React from "react";
import {
  WHEEL_STAGES,
  WHEEL_WEDGES,
} from "@/modules/hub/features/ResourceLibraryV2/components/FilterSidebar/processWheelSegments";

interface ProcessWheelMiniWheelProps {
  activeWheelNames: string[];
}

const ProcessWheelMiniWheel: React.FC<ProcessWheelMiniWheelProps> = ({
  activeWheelNames,
}) => {
  const isActive = (wheelName: string) => activeWheelNames.includes(wheelName);

  return (
    <span className="block h-12 w-12 shrink-0 overflow-hidden rounded-full">
      <svg
        aria-hidden="true"
        className="block"
        height="100%"
        role="presentation"
        viewBox="30 20 940 940"
        width="100%"
      >
        <circle cx="500" cy="490" fill="#15727A" r="470" />

        {WHEEL_STAGES.map((stage) => {
          const active = isActive(stage.wheelName);
          return (
            <path
              d={stage.d}
              data-active={active}
              data-testid={`mini-stage-${stage.id}`}
              fill={stage.fill}
              key={stage.id}
              opacity={active ? 1 : 0.4}
              stroke={active ? "#fff" : "none"}
              strokeWidth={active ? 16 : 0}
            />
          );
        })}

        {WHEEL_WEDGES.map((wedge) => {
          const active = isActive(wedge.wheelName);
          return (
            <path
              d={wedge.d}
              data-active={active}
              data-testid={`mini-wedge-${wedge.id}`}
              fill={wedge.fill}
              key={wedge.id}
              opacity={active ? 1 : 0.35}
              stroke={active ? "#fff" : "none"}
              strokeWidth={active ? 16 : 0}
            />
          );
        })}

        <circle cx="500" cy="490" fill="#FCF6EA" pointerEvents="none" r="90" />
      </svg>
    </span>
  );
};

export default ProcessWheelMiniWheel;
